(function ($) {
 	$.fn.capitechChangePassword = function(options) {
		var $ctChangePasswordElm = $(this);
		// functions
		/*////////////////////////////////////////////////////////////*/
		function init() {
			if (getLocalStorage("showChangePassword") === true) {
				$ctChangePasswordElm.css("display", "block");
			}
			$ctChangePasswordElm.submit(function(evt) {
				evt.preventDefault();
				validateInput();
			});
			if (getURLVariable("password-changed") === "true" && getURLVariable("time-changed")) {
				var secondsSinceChanged = (new Date().getTime() - parseInt(getURLVariable("time-changed"))) / 1000;
				console.log("seconds since changed: " + secondsSinceChanged);
				if (secondsSinceChanged <= 10) {
					sweetAlert(getResource('app.informationTitle'), getResource('profile.passwordIsChanged'), "success");
				}
			}
		}
		
		function validateInput() {
			var oldPassword = $ctChangePasswordElm.find('#old_password').val();
			var newPassword = $ctChangePasswordElm.find('#password').val();
			var newPasswordRepeated = $ctChangePasswordElm.find('#passwordRepeat').val();
			
			if (newPassword === newPasswordRepeated) {
				changePassword(oldPassword, newPassword, newPasswordRepeated);
			} else {
				sweetAlert(getResource('app.informationTitle'), getResource('profile.passwordsIsNotEqual'), "error");
			}
		}
		
		function changePassword(oldPassword, newPassword, newPasswordRepeated) {
			var success = function success(data, textStatus, jqXHR) {
				loaderIndicator(false);
				if (data.success === true) {
					persistTokens(data.content[0]);
					var redirectUrl = updateURLParameter(window.location.href, "password-changed", true);
					redirectUrl = updateURLParameter(redirectUrl, "time-changed", new Date().getTime());
					window.location.href = redirectUrl;
				} else {
					sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
				}
			};
			var error = function error(jqXHR, textStatus, errorThrown) {
				loaderIndicator(false);
				sweetAlert("Error", errorThrown, "error");
			};
			loaderIndicator(true);
			_api.changePassword_POST(success, error, getCookie(ACCESSTOKEN_COOKIE_NAME), oldPassword, newPassword, newPasswordRepeated);
		}
		
		// init
		/*////////////////////////////////////////////////////////////*/
		init();
		
	};
}(jQuery));